export default {
  initDevice: () => {
    console.log('init web device')
  }
}
